var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabela(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.9,5.1H7.5c-1.2,0-2.2,1-2.2,2.2v10.4c0,1.2,1,2.2,2.2,2.2h10.4c1.2,0,2.2-1,2.2-2.2V7.3 C20,6.1,19.1,5.1,17.9,5.1 M6.4,7.3c0-0.6,0.5-1.1,1.1-1.1h10.4c0.6,0,1.1,0.5,1.1,1.1v2.5H6.4V7.3z M12.3,18.8H7.5 c-0.6,0-1.1-0.5-1.1-1.1v-2.5h6V18.8z M12.3,14.1h-6v-3.3h6V14.1z M18.9,17.7c0,0.6-0.5,1.1-1.1,1.1h-4.4v-3.6h5.5V17.7z M18.9,14.1 h-5.5v-3.3h5.5V14.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabela);
export default __webpack_public_path__ + "static/media/tabela.e6e3e239e698c63723319fd41346b3c0.svg";
export { ForwardRef as ReactComponent };